import Logo from "../../assets/Logo.png";
import "./Login.css";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { signin } from "../../actions/Auth";
import TwoFactorStep from "../../twoFactor/TwoFactorStep";
import Input from "./input";
import { Grid, Paper } from "@mui/material";
import { useState } from "react";
import { Button } from "@mui/material";
import RSS from "../../assets/rosoftsavvy.png";

const Login = () => {
  const initialState = {
    email: "",
    password: "",
  };
  const [formData, setFormData] = useState(initialState);
  const [showPassword, setShowPassword] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // Set when the password was right but the authenticator code is still due
  const [twoFactor, setTwoFactor] = useState(null);

  const [submitting, setSubmitting] = useState(false);

  const handleOnSubmit = (e) => {
    e.preventDefault();
    if (submitting) return;
    setSubmitting(true);
    dispatch(signin(formData, navigate))
      .then((pending) => {
        if (pending?.twoFactor) setTwoFactor(pending);
      })
      .finally(() => setSubmitting(false));
  };
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  const handleShowPassword = () =>
    setShowPassword((prevShowPassword) => !prevShowPassword);
  return (
    <div
      style={{ backgroundColor: "#0f172a", height: "100dvh", width: "100%" }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
          paddingBottom: "60px",
        }}
      >
        <div
          className="cbx"
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <h1 style={{ fontSize: "18px" }} className="cbx-title-2">
            CBX - PORTFOLIO MANAGER
          </h1>
          <p className="cbx-subtitle" style={{ marginTop: "-8px" }}>
            Core Banking eXperience
          </p>
        </div>
      </div>
      <Paper
        elevation={0}
        className="paper-page"
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          minWidth: "750px",
          backgroundColor: "#172443",
          borderRadius: 0,
          minHeight: "400px",
        }}
      >
        <div
          style={{
            padding: "20px",
            width: "50%",
            display: "flex",
            alignItems: "flex-start",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <div
            style={{
              marginTop: "-10px",
              display: "flex",
              alignItems: "center",
              flexDirection: "row",
              justifyContent: "center",
            }}
          >
            <div>
              <img width={40} height={"auto"} src={Logo} alt="sekyere" />
            </div>
            <span
              style={{
                fontWeight: "bold",
                color: "#3b82f6",
                fontSize: "1.2rem",
                marginLeft: "5px",
              }}
            >
              NYANKUMASI-AHENKURO COMMUNITY BANK PLC
            </span>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "self-start",
              marginTop: "20px",
            }}
          >
            <span
              style={{
                fontWeight: 600,
                fontFamily: "sans-serif",
                fontSize: "1rem",
                color: "#cbd5e1",
              }}
            >
              Enter your email, we'll check if you are eligible to access this
              system.
            </span>
          </div>
          {twoFactor ? (
            <TwoFactorStep
              step={twoFactor.twoFactor}
              tempToken={twoFactor.tempToken}
              onDone={(data) => dispatch(signin(null, navigate, data))}
              onCancel={() => setTwoFactor(null)}
            />
          ) : (
            <form
              style={{ marginTop: "40px" }}
              className="form-react"
              onSubmit={handleOnSubmit}
            >
              <Grid container spacing={2}>
                <Input
                  autoFocus={true}
                  name="email"
                  placeholder={"Enter Email"}
                  style={{
                    backgroundColor: "#ffffff",
                    border: "1px solid #737373",
                    borderRadius: "5px",
                  }}
                  handleChange={handleChange}
                  type="email"
                />

                <Input
                  name={"password"}
                  placeholder={"Enter your password"}
                  style={{
                    backgroundColor: "#ffffff",
                    border: "1px solid #737373",
                    borderRadius: "5px",
                  }}
                  handleChange={handleChange}
                  type={showPassword ? "text" : "password"}
                  handleShowPassword={handleShowPassword}
                />
              </Grid>
              <div style={{ marginTop: "30px" }}>
                <span style={{ fontSize: "11px", color: "#cbd5e1" }}>
                  By proceeding you acknowledge that if you use your
                  organization's email, your organization may have rights to
                  access and manage your data and account.
                </span>
              </div>

              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Button
                  disableElevation
                  className="submit-react"
                  type="submit"
                  disabled={submitting}
                  id="button"
                  style={{
                    marginTop: "20px",
                    color: "#fff",
                    textTransform: "none",
                    fontWeight: "bold",
                    backgroundColor: "#10b981",
                    fontSize: "1rem",
                  }}
                >
                  {submitting ? "Signing in..." : "Continue"}
                </Button>
              </div>

              <Grid container justifyContent={"center"}>
                <Grid item>
                  <Link
                    style={{
                      textDecoration: "none",
                      fontSize: "1rem",
                      color: "#3b82f6",
                    }}
                    to={"/investment/resetPassword"}
                    className="react-link"
                  >
                    I forgot my password?
                  </Link>
                </Grid>
              </Grid>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#cbd5e1",
                }}
              >
                powered by{" "}
                <img width={20} height={"auto"} src={RSS} alt="rss" />
              </div>
            </form>
          )}
        </div>
        <div
          style={{
            backgroundColor: "#172443",
            height: "420px",
            width: "50%",
            borderLeft: "1px solid #0f172a",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div className="big">
            <h1
              className="bounce-button"
              style={{
                textAlign: "right",
                fontSize: "40px",
                fontWeight: 700,
                color: "#3b82f6",
                textShadow:
                  "0px 0px 10px #fff,0px 0px 20px #fff,0px 0px 40px #fff,0px 0px 80px #fff",
              }}
            >
              WELCOME <br /> BACK!
            </h1>
            <p
              style={{
                textAlign: "right",
                fontWeight: 300,
                fontSize: "16px",
                color: "#d1d5db",
              }}
            >
              Track investments, monitor
              <br />
              performance, and manage
              <br />
              portfolios with clarity
              <br /> and control.
            </p>
          </div>
          {/* something will come here */}
        </div>
      </Paper>
    </div>
  );
};

export default Login;
